import React, { createContext, useContext, useEffect, useState } from "react";

/**
 * FreshDoodh customer i18n.
 *
 * 8 languages: English + 7 Indian languages
 *   en  English
 *   hi  हिन्दी (Hindi)
 *   te  తెలుగు (Telugu)
 *   ta  தமிழ் (Tamil)
 *   kn  ಕನ್ನಡ (Kannada)
 *   mr  मराठी (Marathi)
 *   bn  বাংলা (Bengali)
 *   gu  ગુજરાતી (Gujarati)
 *
 * Translations are translations (not transliterations) where natural;
 * technical terms (OTP, SMS, WhatsApp, brand names) are kept readable.
 */
const translations = {
  en: {
    // greetings
    greeting_morning: "Good morning", greeting_afternoon: "Good afternoon", greeting_evening: "Good evening",
    // wallet
    wallet_balance: "Wallet Balance", recharge: "Recharge", add_money: "Add Money",
    low_balance: "Low balance — recharge to avoid skipped delivery",
    // deliveries
    tomorrow_delivery: "Tomorrow's Delivery", today: "Today", track: "Track",
    pause: "Pause", resume: "Resume", cancel: "Cancel",
    // navigation
    home: "Home", shop: "Shop", subs: "Subs", wallet: "Wallet", me: "Me",
    nav_subscriptions: "Subscriptions",
    // landing
    add_sub: "Add Sub", address: "Address", offers: "Offers", shop_fresh: "Shop Fresh",
    see_all: "See all", from_farm: "From the farm",
    manage_subs: "Manage subscriptions",
    // auth
    sign_in_phone: "Sign in with phone",
    otp_subtitle: "We'll send a one-time password to verify.",
    choose_dairy: "Choose Dairy", choose_channel: "Send OTP via",
    sms: "SMS", whatsapp: "WhatsApp",
    phone_number: "Phone Number", send_otp: "Send OTP", enter_otp: "Enter OTP",
    verify_continue: "Verify & Continue",
    sign_in: "Sign in",
    start_a_store: "Start your own dairy",
    logout: "Logout",
    // misc
    delivery_history: "Delivery History", whatsapp_support: "WhatsApp Support",
    addresses: "Addresses", add: "Add", save_address: "Save Address", new_address: "New Address",
    delivery_boy: "Delivery Boy", admin: "Admin", language: "Language",
    // product detail
    order_once: "Order Once", subscribe_save: "Subscribe & Save",
    one_time_order: "One-time order", subscription_details: "Subscription details",
    quantity: "Quantity", frequency: "Frequency",
    freq_daily: "Daily", freq_alternate: "Alternate", freq_weekly: "Weekly", freq_custom: "Custom",
    days_of_week: "Days of the week",
    day_mon: "Mon", day_tue: "Tue", day_wed: "Wed", day_thu: "Thu",
    day_fri: "Fri", day_sat: "Sat", day_sun: "Sun",
    days_per_week_one: "1 day per week", days_per_week_other: "{n} days per week",
    start_date: "Start Date", delivery_date: "Delivery Date",
    next_available_slot: "Order today, delivered next available slot",
    delivery_slot: "Delivery Slot",
    slot_morning: "Morning", slot_evening: "Evening", slot_both: "Both",
    delivery_address: "Delivery Address", no_address_added: "No address added",
    delivery_instructions: "Delivery Instructions",
    order_total: "Order total", est_monthly_cost: "Est. Monthly Cost",
    place_order: "Place Order", subscribe: "Subscribe", per_delivery: "per delivery",
    placing: "Placing…",
    order_placed: "Order placed!",
    subscription_created: "Subscription created!",
    pick_at_least_one_day: "Pick at least one day",
    please_add_address_first: "Please add an address first",
    // products listing
    shop_title: "Shop", all: "All", all_brands: "All brands",
    no_products_category: "No products in this category",
    showing_only: "Showing only", clear: "clear",
    shop_by_brand: "Shop by brand",
    by: "by",
    off_pct: "% OFF",
    loading: "Loading…",
  },

  hi: {
    greeting_morning: "सुप्रभात", greeting_afternoon: "नमस्कार", greeting_evening: "शुभ संध्या",
    wallet_balance: "वॉलेट बैलेंस", recharge: "रिचार्ज", add_money: "पैसा जोड़ें",
    low_balance: "कम बैलेंस — डिलीवरी से बचने के लिए रिचार्ज करें",
    tomorrow_delivery: "कल की डिलीवरी", today: "आज", track: "ट्रैक",
    pause: "रोकें", resume: "जारी रखें", cancel: "रद्द",
    home: "होम", shop: "दुकान", subs: "सब्सक्रिप्शन", wallet: "वॉलेट", me: "मैं",
    nav_subscriptions: "मेरी सब्सक्रिप्शन",
    add_sub: "जोड़ें", address: "पता", offers: "ऑफर", shop_fresh: "ताज़ा खरीदें",
    see_all: "सभी देखें", from_farm: "खेत से",
    manage_subs: "सब्सक्रिप्शन प्रबंधित करें",
    sign_in_phone: "फ़ोन से साइन इन",
    otp_subtitle: "हम सत्यापन के लिए एक OTP भेजेंगे।",
    choose_dairy: "डेयरी चुनें", choose_channel: "OTP कैसे भेजें",
    sms: "SMS", whatsapp: "व्हाट्सऐप",
    phone_number: "फ़ोन नंबर", send_otp: "OTP भेजें", enter_otp: "OTP दर्ज करें",
    verify_continue: "सत्यापित करें",
    sign_in: "साइन इन",
    start_a_store: "अपनी डेयरी शुरू करें", logout: "लॉगआउट",
    delivery_history: "डिलीवरी इतिहास", whatsapp_support: "व्हाट्सऐप सहायता",
    addresses: "पते", add: "जोड़ें", save_address: "पता सहेजें", new_address: "नया पता",
    delivery_boy: "डिलीवरी बॉय", admin: "एडमिन", language: "भाषा",
    order_once: "एक बार ऑर्डर", subscribe_save: "सब्सक्राइब करें",
    one_time_order: "एक बार का ऑर्डर", subscription_details: "सब्सक्रिप्शन विवरण",
    quantity: "मात्रा", frequency: "आवृत्ति",
    freq_daily: "रोज़", freq_alternate: "एक दिन छोड़कर", freq_weekly: "साप्ताहिक", freq_custom: "कस्टम",
    days_of_week: "सप्ताह के दिन",
    day_mon: "सोम", day_tue: "मंगल", day_wed: "बुध", day_thu: "गुरु",
    day_fri: "शुक्र", day_sat: "शनि", day_sun: "रवि",
    days_per_week_one: "1 दिन प्रति सप्ताह", days_per_week_other: "{n} दिन प्रति सप्ताह",
    start_date: "शुरू तिथि", delivery_date: "डिलीवरी तिथि",
    next_available_slot: "आज ऑर्डर करें, अगले उपलब्ध स्लॉट में डिलीवरी",
    delivery_slot: "डिलीवरी स्लॉट",
    slot_morning: "सुबह", slot_evening: "शाम", slot_both: "दोनों",
    delivery_address: "डिलीवरी पता", no_address_added: "कोई पता नहीं जोड़ा",
    delivery_instructions: "डिलीवरी निर्देश",
    order_total: "कुल राशि", est_monthly_cost: "अनुमानित मासिक लागत",
    place_order: "ऑर्डर करें", subscribe: "सब्सक्राइब", per_delivery: "प्रति डिलीवरी",
    placing: "ऑर्डर हो रहा है…",
    order_placed: "ऑर्डर हो गया!", subscription_created: "सब्सक्रिप्शन बन गई!",
    pick_at_least_one_day: "कम से कम एक दिन चुनें",
    please_add_address_first: "पहले एक पता जोड़ें",
    shop_title: "दुकान", all: "सभी", all_brands: "सभी ब्रांड",
    no_products_category: "इस श्रेणी में कोई उत्पाद नहीं",
    showing_only: "दिखा रहा केवल", clear: "साफ़ करें",
    shop_by_brand: "ब्रांड से खरीदें",
    by: "—",
    off_pct: "% छूट",
    loading: "लोड हो रहा है…",
  },

  te: {
    greeting_morning: "శుభోదయం", greeting_afternoon: "నమస్కారం", greeting_evening: "శుభ సాయంత్రం",
    wallet_balance: "వాలెట్ బ్యాలెన్స్", recharge: "రీఛార్జ్", add_money: "డబ్బు జోడించండి",
    low_balance: "తక్కువ బ్యాలెన్స్ — రీఛార్జ్ చేయండి",
    tomorrow_delivery: "రేపటి డెలివరీ", today: "నేడు", track: "ట్రాక్",
    pause: "నిలిపివేయండి", resume: "తిరిగి ప్రారంభించండి", cancel: "రద్దు",
    home: "హోమ్", shop: "షాప్", subs: "సబ్‌స్క్రిప్షన్", wallet: "వాలెట్", me: "నేను",
    nav_subscriptions: "నా సబ్‌స్క్రిప్షన్‌లు",
    add_sub: "జోడించు", address: "చిరునామా", offers: "ఆఫర్‌లు", shop_fresh: "తాజా షాపింగ్",
    see_all: "అన్నీ చూడండి", from_farm: "ఫామ్ నుండి",
    manage_subs: "సబ్‌స్క్రిప్షన్‌లు నిర్వహించండి",
    sign_in_phone: "ఫోన్‌తో సైన్ ఇన్",
    otp_subtitle: "మేము OTP పంపుతాము.",
    choose_dairy: "డెయిరీ ఎంచుకోండి", choose_channel: "OTP పంపే మాధ్యమం",
    sms: "SMS", whatsapp: "వాట్సాప్",
    phone_number: "ఫోన్ నంబర్", send_otp: "OTP పంపండి", enter_otp: "OTP నమోదు చేయండి",
    verify_continue: "ధృవీకరించండి",
    sign_in: "సైన్ ఇన్",
    start_a_store: "మీ డెయిరీ ప్రారంభించండి", logout: "లాగ్ అవుట్",
    delivery_history: "డెలివరీ చరిత్ర", whatsapp_support: "వాట్సాప్ సహాయం",
    addresses: "చిరునామాలు", add: "జోడించు", save_address: "చిరునామా సేవ్", new_address: "కొత్త చిరునామా",
    delivery_boy: "డెలివరీ బాయ్", admin: "అడ్మిన్", language: "భాష",
    order_once: "ఒకసారి ఆర్డర్", subscribe_save: "సబ్‌స్క్రైబ్ చేయండి",
    one_time_order: "ఒకసారి ఆర్డర్", subscription_details: "సబ్‌స్క్రిప్షన్ వివరాలు",
    quantity: "పరిమాణం", frequency: "ఎంత తరచుగా",
    freq_daily: "ప్రతిరోజూ", freq_alternate: "రోజు విడిచి రోజు", freq_weekly: "వారానికి", freq_custom: "కస్టమ్",
    days_of_week: "వారంలోని రోజులు",
    day_mon: "సోమ", day_tue: "మంగళ", day_wed: "బుధ", day_thu: "గురు",
    day_fri: "శుక్ర", day_sat: "శని", day_sun: "ఆది",
    days_per_week_one: "వారానికి 1 రోజు", days_per_week_other: "వారానికి {n} రోజులు",
    start_date: "ప్రారంభ తేదీ", delivery_date: "డెలివరీ తేదీ",
    next_available_slot: "ఈరోజే ఆర్డర్, తదుపరి స్లాట్‌లో డెలివరీ",
    delivery_slot: "డెలివరీ స్లాట్",
    slot_morning: "ఉదయం", slot_evening: "సాయంత్రం", slot_both: "రెండూ",
    delivery_address: "డెలివరీ చిరునామా", no_address_added: "చిరునామా జోడించలేదు",
    delivery_instructions: "డెలివరీ సూచనలు",
    order_total: "మొత్తం ఆర్డర్", est_monthly_cost: "అంచనా నెలవారీ ఖర్చు",
    place_order: "ఆర్డర్ చేయి", subscribe: "సబ్‌స్క్రైబ్", per_delivery: "ఒక్కో డెలివరీకి",
    placing: "ఆర్డర్ చేస్తున్నాం…",
    order_placed: "ఆర్డర్ ఇచ్చారు!", subscription_created: "సబ్‌స్క్రిప్షన్ సృష్టించబడింది!",
    pick_at_least_one_day: "కనీసం ఒక రోజు ఎంచుకోండి",
    please_add_address_first: "మొదట చిరునామా జోడించండి",
    shop_title: "షాప్", all: "అన్నీ", all_brands: "అన్ని బ్రాండ్‌లు",
    no_products_category: "ఈ వర్గంలో ఉత్పత్తులు లేవు",
    showing_only: "మాత్రమే చూపుతున్నాం", clear: "క్లియర్",
    shop_by_brand: "బ్రాండ్ ద్వారా షాప్",
    by: "—",
    off_pct: "% డిస్కౌంట్",
    loading: "లోడ్ అవుతోంది…",
  },

  ta: {
    greeting_morning: "காலை வணக்கம்", greeting_afternoon: "மதிய வணக்கம்", greeting_evening: "மாலை வணக்கம்",
    wallet_balance: "வாலட் இருப்பு", recharge: "ரீசார்ஜ்", add_money: "பணம் சேர்",
    low_balance: "குறைந்த இருப்பு — ரீசார்ஜ் செய்யவும்",
    tomorrow_delivery: "நாளைய டெலிவரி", today: "இன்று", track: "கண்காணி",
    pause: "இடைநிறுத்து", resume: "தொடரவும்", cancel: "ரத்து",
    home: "முகப்பு", shop: "கடை", subs: "சந்தா", wallet: "வாலட்", me: "நான்",
    nav_subscriptions: "எனது சந்தாக்கள்",
    add_sub: "சேர்", address: "முகவரி", offers: "சலுகை", shop_fresh: "புதிய வாங்க",
    see_all: "அனைத்தும்", from_farm: "பண்ணையிலிருந்து",
    manage_subs: "சந்தாக்களை நிர்வகி",
    sign_in_phone: "ஃபோனில் உள்நுழை",
    otp_subtitle: "OTP அனுப்பப்படும்.",
    choose_dairy: "டெய்ரி தேர்வு", choose_channel: "OTP அனுப்பு",
    sms: "SMS", whatsapp: "வாட்ஸ்ஆப்",
    phone_number: "ஃபோன் எண்", send_otp: "OTP அனுப்பு", enter_otp: "OTP உள்ளிடவும்",
    verify_continue: "சரிபார்",
    sign_in: "உள்நுழை",
    start_a_store: "உங்கள் டெய்ரி தொடங்க", logout: "வெளியேறு",
    delivery_history: "டெலிவரி வரலாறு", whatsapp_support: "வாட்ஸ்ஆப் ஆதரவு",
    addresses: "முகவரிகள்", add: "சேர்", save_address: "முகவரி சேமி", new_address: "புதிய முகவரி",
    delivery_boy: "டெலிவரி பாய்", admin: "நிர்வாகி", language: "மொழி",
    order_once: "ஒருமுறை ஆர்டர்", subscribe_save: "சந்தா பதிவு",
    one_time_order: "ஒருமுறை ஆர்டர்", subscription_details: "சந்தா விவரங்கள்",
    quantity: "அளவு", frequency: "அடிக்கடி",
    freq_daily: "தினமும்", freq_alternate: "ஒரு நாள் இடைவெளியில்", freq_weekly: "வாரம்", freq_custom: "தனிப்பயன்",
    days_of_week: "வாரத்தின் நாட்கள்",
    day_mon: "திங்", day_tue: "செவ்", day_wed: "புத", day_thu: "வியா",
    day_fri: "வெள்", day_sat: "சனி", day_sun: "ஞாயி",
    days_per_week_one: "வாரத்திற்கு 1 நாள்", days_per_week_other: "வாரத்திற்கு {n} நாட்கள்",
    start_date: "தொடக்க தேதி", delivery_date: "டெலிவரி தேதி",
    next_available_slot: "இன்றே ஆர்டர், அடுத்த இடத்தில் டெலிவரி",
    delivery_slot: "டெலிவரி இடம்",
    slot_morning: "காலை", slot_evening: "மாலை", slot_both: "இரண்டும்",
    delivery_address: "டெலிவரி முகவரி", no_address_added: "முகவரி இல்லை",
    delivery_instructions: "டெலிவரி குறிப்புகள்",
    order_total: "மொத்த ஆர்டர்", est_monthly_cost: "மாதாந்திர கணிப்பு",
    place_order: "ஆர்டர் செய்", subscribe: "சந்தாதாரர்", per_delivery: "ஒரு டெலிவரிக்கு",
    placing: "ஆர்டர் செய்கிறோம்…",
    order_placed: "ஆர்டர் வைக்கப்பட்டது!", subscription_created: "சந்தா உருவாக்கப்பட்டது!",
    pick_at_least_one_day: "ஒரு நாளையாவது தேர்வு செய்யவும்",
    please_add_address_first: "முதலில் முகவரி சேர்க்கவும்",
    shop_title: "கடை", all: "அனைத்தும்", all_brands: "அனைத்து பிராண்டுகள்",
    no_products_category: "இந்த வகையில் தயாரிப்புகள் இல்லை",
    showing_only: "மட்டும் காட்டுகிறது", clear: "அழி",
    shop_by_brand: "பிராண்டால் கடை",
    by: "—",
    off_pct: "% தள்ளுபடி",
    loading: "ஏற்றுகிறது…",
  },

  kn: {
    greeting_morning: "ಶುಭೋದಯ", greeting_afternoon: "ನಮಸ್ಕಾರ", greeting_evening: "ಶುಭ ಸಂಜೆ",
    wallet_balance: "ವಾಲೆಟ್ ಬ್ಯಾಲೆನ್ಸ್", recharge: "ರೀಚಾರ್ಜ್", add_money: "ಹಣ ಸೇರಿಸಿ",
    low_balance: "ಕಡಿಮೆ ಬ್ಯಾಲೆನ್ಸ್ — ರೀಚಾರ್ಜ್ ಮಾಡಿ",
    tomorrow_delivery: "ನಾಳಿನ ಡೆಲಿವರಿ", today: "ಇಂದು", track: "ಟ್ರ್ಯಾಕ್",
    pause: "ವಿರಾಮ", resume: "ಮುಂದುವರಿಸಿ", cancel: "ರದ್ದು",
    home: "ಮುಖ", shop: "ಶಾಪ್", subs: "ಸಬ್ಸ್", wallet: "ವಾಲೆಟ್", me: "ನಾನು",
    nav_subscriptions: "ನನ್ನ ಸಬ್ಸ್ಕ್ರಿಪ್ಶನ್‌ಗಳು",
    add_sub: "ಸೇರಿಸಿ", address: "ವಿಳಾಸ", offers: "ಆಫರ್‌ಗಳು", shop_fresh: "ತಾಜಾ ಶಾಪಿಂಗ್",
    see_all: "ಎಲ್ಲಾ", from_farm: "ಫಾರ್ಮ್‌ನಿಂದ",
    manage_subs: "ಸಬ್ಸ್ಕ್ರಿಪ್ಶನ್ ನಿರ್ವಹಿಸಿ",
    sign_in_phone: "ಫೋನ್‌ನಿಂದ ಸೈನ್ ಇನ್",
    otp_subtitle: "OTP ಕಳುಹಿಸಲಾಗುತ್ತದೆ.",
    choose_dairy: "ಡೈರಿ ಆಯ್ಕೆಮಾಡಿ", choose_channel: "OTP ಕಳುಹಿಸುವ ವಿಧಾನ",
    sms: "SMS", whatsapp: "ವಾಟ್ಸಾಪ್",
    phone_number: "ಫೋನ್ ಸಂಖ್ಯೆ", send_otp: "OTP ಕಳುಹಿಸಿ", enter_otp: "OTP ನಮೂದಿಸಿ",
    verify_continue: "ಪರಿಶೀಲಿಸಿ",
    sign_in: "ಸೈನ್ ಇನ್",
    start_a_store: "ನಿಮ್ಮ ಡೈರಿ ಪ್ರಾರಂಭಿಸಿ", logout: "ಲಾಗೌಟ್",
    delivery_history: "ಡೆಲಿವರಿ ಇತಿಹಾಸ", whatsapp_support: "ವಾಟ್ಸಾಪ್ ಸಪೋರ್ಟ್",
    addresses: "ವಿಳಾಸಗಳು", add: "ಸೇರಿಸಿ", save_address: "ವಿಳಾಸ ಉಳಿಸಿ", new_address: "ಹೊಸ ವಿಳಾಸ",
    delivery_boy: "ಡೆಲಿವರಿ ಬಾಯ್", admin: "ಅಡ್ಮಿನ್", language: "ಭಾಷೆ",
    order_once: "ಒಮ್ಮೆ ಆರ್ಡರ್", subscribe_save: "ಚಂದಾದಾರರಾಗಿ",
    one_time_order: "ಒಮ್ಮೆ ಆರ್ಡರ್", subscription_details: "ಚಂದಾ ವಿವರಗಳು",
    quantity: "ಪ್ರಮಾಣ", frequency: "ಆವರ್ತನ",
    freq_daily: "ಪ್ರತಿದಿನ", freq_alternate: "ಪರ್ಯಾಯ ದಿನ", freq_weekly: "ವಾರಕ್ಕೆ", freq_custom: "ಕಸ್ಟಮ್",
    days_of_week: "ವಾರದ ದಿನಗಳು",
    day_mon: "ಸೋಮ", day_tue: "ಮಂಗಳ", day_wed: "ಬುಧ", day_thu: "ಗುರು",
    day_fri: "ಶುಕ್ರ", day_sat: "ಶನಿ", day_sun: "ಭಾನು",
    days_per_week_one: "ವಾರಕ್ಕೆ 1 ದಿನ", days_per_week_other: "ವಾರಕ್ಕೆ {n} ದಿನಗಳು",
    start_date: "ಪ್ರಾರಂಭ ದಿನಾಂಕ", delivery_date: "ಡೆಲಿವರಿ ದಿನಾಂಕ",
    next_available_slot: "ಇಂದು ಆರ್ಡರ್, ಮುಂದಿನ ಸ್ಲಾಟ್‌ನಲ್ಲಿ ಡೆಲಿವರಿ",
    delivery_slot: "ಡೆಲಿವರಿ ಸ್ಲಾಟ್",
    slot_morning: "ಬೆಳಿಗ್ಗೆ", slot_evening: "ಸಂಜೆ", slot_both: "ಎರಡೂ",
    delivery_address: "ಡೆಲಿವರಿ ವಿಳಾಸ", no_address_added: "ವಿಳಾಸ ಸೇರಿಸಿಲ್ಲ",
    delivery_instructions: "ಡೆಲಿವರಿ ಸೂಚನೆಗಳು",
    order_total: "ಒಟ್ಟು", est_monthly_cost: "ಮಾಸಿಕ ಅಂದಾಜು",
    place_order: "ಆರ್ಡರ್ ಮಾಡಿ", subscribe: "ಚಂದಾದಾರರಾಗಿ", per_delivery: "ಒಂದು ಡೆಲಿವರಿಗೆ",
    placing: "ಆರ್ಡರ್ ಮಾಡುತ್ತಿದ್ದೇವೆ…",
    order_placed: "ಆರ್ಡರ್ ಮಾಡಲಾಗಿದೆ!", subscription_created: "ಚಂದಾ ರಚಿಸಲಾಗಿದೆ!",
    pick_at_least_one_day: "ಕನಿಷ್ಠ ಒಂದು ದಿನವನ್ನು ಆಯ್ಕೆಮಾಡಿ",
    please_add_address_first: "ಮೊದಲು ವಿಳಾಸ ಸೇರಿಸಿ",
    shop_title: "ಶಾಪ್", all: "ಎಲ್ಲಾ", all_brands: "ಎಲ್ಲಾ ಬ್ರಾಂಡ್‌ಗಳು",
    no_products_category: "ಈ ವರ್ಗದಲ್ಲಿ ಉತ್ಪನ್ನಗಳಿಲ್ಲ",
    showing_only: "ಮಾತ್ರ ತೋರಿಸಲಾಗಿದೆ", clear: "ತೆರವುಗೊಳಿಸಿ",
    shop_by_brand: "ಬ್ರಾಂಡ್ ಮೂಲಕ ಶಾಪಿಂಗ್",
    by: "—",
    off_pct: "% ಡಿಸ್ಕೌಂಟ್",
    loading: "ಲೋಡ್ ಆಗುತ್ತಿದೆ…",
  },

  mr: {
    greeting_morning: "शुभ सकाळ", greeting_afternoon: "नमस्कार", greeting_evening: "शुभ संध्याकाळ",
    wallet_balance: "वॉलेट शिल्लक", recharge: "रिचार्ज", add_money: "पैसे जोडा",
    low_balance: "कमी शिल्लक — डिलिव्हरी टाळण्यासाठी रिचार्ज करा",
    tomorrow_delivery: "उद्याची डिलिव्हरी", today: "आज", track: "ट्रॅक",
    pause: "थांबवा", resume: "सुरू ठेवा", cancel: "रद्द",
    home: "होम", shop: "दुकान", subs: "सब्सक्रिप्शन", wallet: "वॉलेट", me: "मी",
    nav_subscriptions: "माझी सब्सक्रिप्शन्स",
    add_sub: "जोडा", address: "पत्ता", offers: "ऑफर्स", shop_fresh: "ताजे खरेदी",
    see_all: "सर्व पहा", from_farm: "शेतातून",
    manage_subs: "सब्सक्रिप्शन व्यवस्थापित करा",
    sign_in_phone: "फोनवरून साइन इन",
    otp_subtitle: "आम्ही पडताळणीसाठी OTP पाठवू.",
    choose_dairy: "डेअरी निवडा", choose_channel: "OTP कसा पाठवायचा",
    sms: "SMS", whatsapp: "व्हॉट्सअ‍ॅप",
    phone_number: "फोन क्रमांक", send_otp: "OTP पाठवा", enter_otp: "OTP प्रविष्ट करा",
    verify_continue: "पडताळा",
    sign_in: "साइन इन",
    start_a_store: "तुमची डेअरी सुरू करा", logout: "लॉगआउट",
    delivery_history: "डिलिव्हरी इतिहास", whatsapp_support: "व्हॉट्सअ‍ॅप मदत",
    addresses: "पत्ते", add: "जोडा", save_address: "पत्ता जतन करा", new_address: "नवीन पत्ता",
    delivery_boy: "डिलिव्हरी बॉय", admin: "अ‍ॅडमिन", language: "भाषा",
    order_once: "एकदा ऑर्डर", subscribe_save: "सब्सक्राइब करा",
    one_time_order: "एकदा चे ऑर्डर", subscription_details: "सब्सक्रिप्शन तपशील",
    quantity: "प्रमाण", frequency: "वारंवारता",
    freq_daily: "रोज", freq_alternate: "एक दिवस आड", freq_weekly: "साप्ताहिक", freq_custom: "कस्टम",
    days_of_week: "आठवड्याचे दिवस",
    day_mon: "सोम", day_tue: "मंगळ", day_wed: "बुध", day_thu: "गुरु",
    day_fri: "शुक्र", day_sat: "शनि", day_sun: "रवि",
    days_per_week_one: "आठवड्यात 1 दिवस", days_per_week_other: "आठवड्यात {n} दिवस",
    start_date: "सुरुवात तारीख", delivery_date: "डिलिव्हरी तारीख",
    next_available_slot: "आज ऑर्डर करा, पुढच्या उपलब्ध स्लॉटमध्ये डिलिव्हरी",
    delivery_slot: "डिलिव्हरी स्लॉट",
    slot_morning: "सकाळ", slot_evening: "संध्याकाळ", slot_both: "दोन्ही",
    delivery_address: "डिलिव्हरी पत्ता", no_address_added: "पत्ता जोडलेला नाही",
    delivery_instructions: "डिलिव्हरी सूचना",
    order_total: "एकूण रक्कम", est_monthly_cost: "मासिक अंदाज",
    place_order: "ऑर्डर करा", subscribe: "सब्सक्राइब", per_delivery: "प्रति डिलिव्हरी",
    placing: "ऑर्डर होत आहे…",
    order_placed: "ऑर्डर झाला!", subscription_created: "सब्सक्रिप्शन तयार झाली!",
    pick_at_least_one_day: "किमान एक दिवस निवडा",
    please_add_address_first: "आधी पत्ता जोडा",
    shop_title: "दुकान", all: "सर्व", all_brands: "सर्व ब्रँड",
    no_products_category: "या श्रेणीत उत्पादने नाहीत",
    showing_only: "फक्त दाखवत आहे", clear: "साफ करा",
    shop_by_brand: "ब्रँडनुसार खरेदी",
    by: "—",
    off_pct: "% सूट",
    loading: "लोड होत आहे…",
  },

  bn: {
    greeting_morning: "শুভ সকাল", greeting_afternoon: "নমস্কার", greeting_evening: "শুভ সন্ধ্যা",
    wallet_balance: "ওয়ালেট ব্যালেন্স", recharge: "রিচার্জ", add_money: "টাকা যোগ করুন",
    low_balance: "কম ব্যালেন্স — ডেলিভারি এড়াতে রিচার্জ করুন",
    tomorrow_delivery: "আগামীকালের ডেলিভারি", today: "আজ", track: "ট্র্যাক",
    pause: "বিরতি", resume: "চালিয়ে যান", cancel: "বাতিল",
    home: "হোম", shop: "শপ", subs: "সাবস্ক্রিপশন", wallet: "ওয়ালেট", me: "আমি",
    nav_subscriptions: "আমার সাবস্ক্রিপশন",
    add_sub: "যোগ করুন", address: "ঠিকানা", offers: "অফার", shop_fresh: "তাজা কিনুন",
    see_all: "সব দেখুন", from_farm: "খামার থেকে",
    manage_subs: "সাবস্ক্রিপশন পরিচালনা করুন",
    sign_in_phone: "ফোন দিয়ে সাইন ইন",
    otp_subtitle: "আমরা যাচাইয়ের জন্য একটি OTP পাঠাব।",
    choose_dairy: "ডেইরি বাছুন", choose_channel: "OTP কীভাবে পাঠাবেন",
    sms: "SMS", whatsapp: "হোয়াটসঅ্যাপ",
    phone_number: "ফোন নম্বর", send_otp: "OTP পাঠান", enter_otp: "OTP লিখুন",
    verify_continue: "যাচাই করুন",
    sign_in: "সাইন ইন",
    start_a_store: "আপনার নিজস্ব ডেইরি শুরু করুন", logout: "লগআউট",
    delivery_history: "ডেলিভারি ইতিহাস", whatsapp_support: "হোয়াটসঅ্যাপ সাহায্য",
    addresses: "ঠিকানা", add: "যোগ করুন", save_address: "ঠিকানা সংরক্ষণ", new_address: "নতুন ঠিকানা",
    delivery_boy: "ডেলিভারি বয়", admin: "অ্যাডমিন", language: "ভাষা",
    order_once: "একবারের অর্ডার", subscribe_save: "সাবস্ক্রাইব করুন",
    one_time_order: "একবারের অর্ডার", subscription_details: "সাবস্ক্রিপশন বিবরণ",
    quantity: "পরিমাণ", frequency: "কতবার",
    freq_daily: "প্রতিদিন", freq_alternate: "একদিন পর পর", freq_weekly: "সাপ্তাহিক", freq_custom: "কাস্টম",
    days_of_week: "সপ্তাহের দিন",
    day_mon: "সোম", day_tue: "মঙ্গল", day_wed: "বুধ", day_thu: "বৃহ",
    day_fri: "শুক্র", day_sat: "শনি", day_sun: "রবি",
    days_per_week_one: "সপ্তাহে 1 দিন", days_per_week_other: "সপ্তাহে {n} দিন",
    start_date: "শুরুর তারিখ", delivery_date: "ডেলিভারি তারিখ",
    next_available_slot: "আজই অর্ডার করুন, পরবর্তী স্লটে ডেলিভারি",
    delivery_slot: "ডেলিভারি স্লট",
    slot_morning: "সকাল", slot_evening: "সন্ধ্যা", slot_both: "উভয়",
    delivery_address: "ডেলিভারি ঠিকানা", no_address_added: "কোনো ঠিকানা যোগ করা নেই",
    delivery_instructions: "ডেলিভারি নির্দেশনা",
    order_total: "মোট অর্ডার", est_monthly_cost: "মাসিক আনুমানিক খরচ",
    place_order: "অর্ডার দিন", subscribe: "সাবস্ক্রাইব", per_delivery: "প্রতি ডেলিভারি",
    placing: "অর্ডার করা হচ্ছে…",
    order_placed: "অর্ডার সম্পন্ন!", subscription_created: "সাবস্ক্রিপশন তৈরি হয়েছে!",
    pick_at_least_one_day: "কমপক্ষে একদিন বেছে নিন",
    please_add_address_first: "প্রথমে একটি ঠিকানা যোগ করুন",
    shop_title: "শপ", all: "সব", all_brands: "সব ব্র্যান্ড",
    no_products_category: "এই বিভাগে কোনো পণ্য নেই",
    showing_only: "শুধু দেখানো হচ্ছে", clear: "মুছুন",
    shop_by_brand: "ব্র্যান্ড অনুযায়ী কিনুন",
    by: "—",
    off_pct: "% ছাড়",
    loading: "লোড হচ্ছে…",
  },

  gu: {
    greeting_morning: "સુપ્રભાત", greeting_afternoon: "નમસ્કાર", greeting_evening: "શુભ સાંજ",
    wallet_balance: "વૉલેટ બેલેન્સ", recharge: "રિચાર્જ", add_money: "પૈસા ઉમેરો",
    low_balance: "ઓછું બેલેન્સ — ડિલિવરી ટાળવા રિચાર્જ કરો",
    tomorrow_delivery: "આવતી કાલની ડિલિવરી", today: "આજે", track: "ટ્રૅક",
    pause: "થોભાવો", resume: "ચાલુ રાખો", cancel: "રદ",
    home: "હોમ", shop: "દુકાન", subs: "સબ્સ્ક્રિપ્શન", wallet: "વૉલેટ", me: "હું",
    nav_subscriptions: "મારી સબ્સ્ક્રિપ્શન",
    add_sub: "ઉમેરો", address: "સરનામું", offers: "ઑફર્સ", shop_fresh: "તાજું ખરીદો",
    see_all: "બધું જુઓ", from_farm: "ખેતરથી",
    manage_subs: "સબ્સ્ક્રિપ્શન મેનેજ કરો",
    sign_in_phone: "ફોનથી સાઇન ઇન",
    otp_subtitle: "ચકાસણી માટે અમે OTP મોકલીશું.",
    choose_dairy: "ડેરી પસંદ કરો", choose_channel: "OTP કેવી રીતે મોકલવો",
    sms: "SMS", whatsapp: "વોટ્સએપ",
    phone_number: "ફોન નંબર", send_otp: "OTP મોકલો", enter_otp: "OTP દાખલ કરો",
    verify_continue: "ચકાસો",
    sign_in: "સાઇન ઇન",
    start_a_store: "તમારી ડેરી શરૂ કરો", logout: "લોગઆઉટ",
    delivery_history: "ડિલિવરી ઇતિહાસ", whatsapp_support: "વોટ્સએપ સહાય",
    addresses: "સરનામાં", add: "ઉમેરો", save_address: "સરનામું સાચવો", new_address: "નવું સરનામું",
    delivery_boy: "ડિલિવરી બોય", admin: "એડમિન", language: "ભાષા",
    order_once: "એક વાર ઓર્ડર", subscribe_save: "સબ્સ્ક્રાઇબ કરો",
    one_time_order: "એક વારનો ઓર્ડર", subscription_details: "સબ્સ્ક્રિપ્શન વિગતો",
    quantity: "જથ્થો", frequency: "આવર્તન",
    freq_daily: "દરરોજ", freq_alternate: "એક દિવસ છોડીને", freq_weekly: "સાપ્તાહિક", freq_custom: "કસ્ટમ",
    days_of_week: "અઠવાડિયાના દિવસો",
    day_mon: "સોમ", day_tue: "મંગળ", day_wed: "બુધ", day_thu: "ગુરુ",
    day_fri: "શુક્ર", day_sat: "શનિ", day_sun: "રવિ",
    days_per_week_one: "અઠવાડિયે 1 દિવસ", days_per_week_other: "અઠવાડિયે {n} દિવસ",
    start_date: "શરૂ તારીખ", delivery_date: "ડિલિવરી તારીખ",
    next_available_slot: "આજે ઓર્ડર કરો, આગામી સ્લોટમાં ડિલિવરી",
    delivery_slot: "ડિલિવરી સ્લોટ",
    slot_morning: "સવાર", slot_evening: "સાંજ", slot_both: "બંને",
    delivery_address: "ડિલિવરી સરનામું", no_address_added: "કોઈ સરનામું ઉમેર્યું નથી",
    delivery_instructions: "ડિલિવરી સૂચનાઓ",
    order_total: "કુલ ઓર્ડર", est_monthly_cost: "મહિનાનો અંદાજ",
    place_order: "ઓર્ડર કરો", subscribe: "સબ્સ્ક્રાઇબ", per_delivery: "પ્રતિ ડિલિવરી",
    placing: "ઓર્ડર થઈ રહ્યો છે…",
    order_placed: "ઓર્ડર સફળ!", subscription_created: "સબ્સ્ક્રિપ્શન બની!",
    pick_at_least_one_day: "ઓછામાં ઓછો એક દિવસ પસંદ કરો",
    please_add_address_first: "પહેલા સરનામું ઉમેરો",
    shop_title: "દુકાન", all: "બધું", all_brands: "બધી બ્રાન્ડ્સ",
    no_products_category: "આ શ્રેણીમાં કોઈ ઉત્પાદનો નથી",
    showing_only: "માત્ર બતાવી રહ્યું છે", clear: "સાફ કરો",
    shop_by_brand: "બ્રાન્ડ પ્રમાણે ખરીદો",
    by: "—",
    off_pct: "% છૂટ",
    loading: "લોડ થઈ રહ્યું છે…",
  },
};

export const LANGUAGES = [
  { code: "en", label: "English",   native: "English" },
  { code: "hi", label: "Hindi",     native: "हिन्दी" },
  { code: "te", label: "Telugu",    native: "తెలుగు" },
  { code: "ta", label: "Tamil",     native: "தமிழ்" },
  { code: "kn", label: "Kannada",   native: "ಕನ್ನಡ" },
  { code: "mr", label: "Marathi",   native: "मराठी" },
  { code: "bn", label: "Bengali",   native: "বাংলা" },
  { code: "gu", label: "Gujarati",  native: "ગુજરાતી" },
];

const I18nCtx = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("fd_lang") || "en");
  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("fd_lang", l);
  };
  useEffect(() => {
    // Reflect to <html lang=…> for assistive tech + future Web Speech
    document.documentElement.lang = lang;
  }, [lang]);

  // t(key, params?) — supports simple {n} interpolation
  const t = (key, params) => {
    const raw = translations[lang]?.[key] ?? translations.en[key] ?? key;
    if (!params) return raw;
    return Object.entries(params).reduce(
      (acc, [k, v]) => acc.replaceAll(`{${k}}`, String(v)),
      raw,
    );
  };
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useT = () => useContext(I18nCtx);
